<template>
  <ul
    v-if="item.type !== 'contact'"
    class="site-footer__navlist navlist"
  >
    <li
      v-for="(link, subIndex) of item.sublinks"
      :key="`footer-sublink-${subIndex}`"
      class="site-footer__navlist-item"
    >
      <a
        class="site-footer__navlist-link text-body-s-regular"
        :aria-label="link.title"
        :title="link.title"
        :href="link.url"
      >
        {{ link.title }}
      </a>
    </li>
  </ul>
  <template v-if="item.type === 'contact'">
    <div v-html="item.content" />
  </template>
</template>

<script>

/**
 * Vue: Site footer menu
 * -----------------------------------------------------------------------------
 * Site footer component that renders a menu list,
 *
 */
export default {
  name: 'SiteFooterMenu',

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  mounted() {
    // empty
  },

}
</script>
